import React from "react";
import "./SupportTicketCard.css";

const SupportTicketCard = ({ ticket, onClick }) => {
  const { _id, subject, description, status, unread_count } = ticket || {};

  const handleClick = () => {
    if (onClick && status !== "closed") {
      onClick(_id);
    }
  };

  return (
    <div className="support-ticket-card" onClick={handleClick}>
      <div className="ticket-header">
        <h3 className="ticket-subject">{subject}</h3>
        <div className="ticket-status-wrap">
          <span className={`ticket-status ${status}`}>{status}</span>
        </div>
      </div>
      <div className="ticket-bottom">
        <p className="ticket-description">{description}</p>
        {Number(unread_count) > 0 && status === "open" && (
          <span className="unread-badge">
            {Number(unread_count) > 100 ? "100+" : unread_count}
          </span>
        )}
      </div>
    </div>
  );
};

export default SupportTicketCard;
